'use strict';

(function (global) {

  /**
   * Базовый класс настроек предпросмотра.
   *
   * @since 5.7.0
   */
  class BaseDocumentPreviewSettings {

    /**
     * Масштабирование по умолчанию.
     *
     * @property defaultScale
     * @return {string} Значение масштабирования по умолчанию.
     * @static
     */
    static get defaultScale() {
      return '';
    }

    /**
     * Имя группы набора свойств.
     *
     * @property storageGroupName
     * @return {string} Имя группы набора свойств.
     */
    get storageGroupName() {
      if (!this._location) {
        this._location = WA.getLocation();
        // Если предпросмотр открыт в полноэкранном режиме, то настройки нужно получить, как для обычного
        if (this._location === 'documentpreview') {
          this._location = 'doc';
        }
      }
      return this._location;
    }

    /**
     * Видимость комментариев.
     *
     * @property commentsVisibility
     * @returns {boolean} Видимость комментариев.
     */
    get commentsVisibility() {
      return false;
    }
    set commentsVisibility(isVisible) { }

    /**
     * Видимость изменений.
     *
     * @property trackChangesVisibility
     * @returns {boolean} Видимость изменений.
     */
    get trackChangesVisibility() {
      return false;
    }
    set trackChangesVisibility(isVisible) { }

    /**
     * Масштабирование.
     *
     * @property previewScale
     * @returns {string} Масштабирование.
     */
    get previewScale() {
      return localStorage.getItem(this._previewScaleStorageName) || this.constructor.defaultScale;
    }
    set previewScale(scale) {
      if (scale) {
        localStorage.setItem(this._previewScaleStorageName, scale);
      }
    }

  }

  global.BaseDocumentPreviewSettings = BaseDocumentPreviewSettings;

})(window.Core.preview);